/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GuardianDto } from '../../models/guardian-dto';

export interface UserGuardianControllerChangeMainGuardian$Params {
  childId: string;
  parentId: string;
  centerId: string;
}

export function userGuardianControllerChangeMainGuardian(http: HttpClient, rootUrl: string, params: UserGuardianControllerChangeMainGuardian$Params, context?: HttpContext): Observable<StrictHttpResponse<GuardianDto>> {
  const rb = new RequestBuilder(rootUrl, userGuardianControllerChangeMainGuardian.PATH, 'patch');
  if (params) {
    rb.query('childId', params.childId, {});
    rb.query('parentId', params.parentId, {});
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GuardianDto>;
    })
  );
}

userGuardianControllerChangeMainGuardian.PATH = '/api/guardian/user/change';
